import BaseView from './BaseView';
import StoryMenu from '../../components/StoryMenu';

let view = null;

class Story extends BaseView {
	constructor(container) {
		super(container);
		this.hasScript = false;
	}

	init() {
		this.container.querySelectorAll('[data-story-menu]').forEach((menu) => {
			this.modules.push(new StoryMenu(menu, this.container));
		});
	}
}

export default {
	namespace: 'single-story',
	beforeEnter: ({ current, next, trigger }) => {
		view = new Story(next.container);
		view.init();
	},
	afterLeave: ({ current, next, trigger }) => {
		view.destroy();
		view = null;
	},
};
